var React = require("react");

require("./MemberBenefitsTable.scss");

var memberBenefitsTableRows = [
	{
		title: 'Men\'s Ticket on-sale access',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: true
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'Additional 24-hour Men\'s ticket access window',
		juniorOneHotspur: {
			price: '',
			included: false
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'Ticket Exchange and Ticket Transfer access',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: true
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'Season Ticket Waiting List Position',
		juniorOneHotspur: {
			price: '',
			included: false
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'One Hotspur Moments - our Loyalty & Rewards Program',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: true
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'Junior Membership Pack',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: false
		}
	},
	{
		title: 'Retail Voucher',
		juniorOneHotspur: {
			price: '',
			included: false
		},
		juniorOneHotspurPlus: {
			price: '',
			included: false
		},
		adultOneHotspur: {
			price: '15',
			included: true
		},
		adultOneHotspurPlus: {
			price: '20',
			included: true
		}
	},
	{
		title: 'Stadium Attraction Voucher (includes F1® DRIVE)',
		juniorOneHotspur: {
			price: '',
			included: false
		},
		juniorOneHotspurPlus: {
			price: '',
			included: false
		},
		adultOneHotspur: {
			price: '10',
			included: true
		},
		adultOneHotspurPlus: {
			price: '15',
			included: true
		}
	},
	{
		title: 'Free Stadium Tour',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: false
		}
	},
	{
		title: '£10 SPURSPLAY Discount',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: true
		},
		adultOneHotspurPlus: {
			price: '',
			included: true
		}
	},
	{
		title: 'Entry to the Junior Mascot Ballot',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: false
		}
	},
	{
		title: 'Free entry to Women\'s matches',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: false
		}
	},
	{
		title: '10% off evening and holiday Football Development Programmes',
		juniorOneHotspur: {
			price: '',
			included: true
		},
		juniorOneHotspurPlus: {
			price: '',
			included: true
		},
		adultOneHotspur: {
			price: '',
			included: false
		},
		adultOneHotspurPlus: {
			price: '',
			included: false
		}
	}
];

const classPrefix = `c-benefits-table`;

class BenefitsTableModule extends React.Component {
	render() {
		
		return (
			<div id="member-benefits-table" className="c-section c-section--benefits-table c-section--always-padded">
				<div className="c-section__inner">
					<div className="c-section__inner__inner">

						<div className={`${classPrefix}`}>
							<div className={`${classPrefix}__container`}>
								<h2 className={`${classPrefix}__title`}>Choose your <span className="c-benefits-table__title__membership">Membership</span></h2>
								<div className={`${classPrefix}__prices`}>
									<p className={`${classPrefix}__prices__price`}>Junior One Hotspur <strong>from</strong> &pound;20</p>
									<p className={`${classPrefix}__prices__price`}>Junior One Hotspur+ <strong>from</strong> &pound;25</p>
									<p className={`${classPrefix}__prices__price`}>Adult One Hotspur <strong>from</strong> &pound;45</p>
									<p className={`${classPrefix}__prices__price`}>Adult One Hotspur+ <strong>from</strong> &pound;55</p>
								</div>
								<div className={`${classPrefix}__table`}>
									<div className={`${classPrefix}__table__row ${classPrefix}__table__row--header`}>
										<div className={`${classPrefix}__table__cell ${classPrefix}__table__cell--title`}>Benefits</div>
										<div className={`${classPrefix}__table__cell`}>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--desktop`}>Junior<br/> One Hotspur<span className={`${classPrefix}__table__cell__content__price`}>From &pound;20</span></span>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--mobile`}>Junior OH</span>
										</div>
										<div className={`${classPrefix}__table__cell`}>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--desktop`}>Junior<br/> One Hotspur+<span className={`${classPrefix}__table__cell__content__price`}>From &pound;25</span></span>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--mobile`}>Junior OH+</span>
										</div>
										<div className={`${classPrefix}__table__cell`}>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--desktop`}>Adult<br/> One Hotspur<span className={`${classPrefix}__table__cell__content__price`}>From &pound;45</span></span>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--mobile`}>Adult OH</span>
										</div>
										<div className={`${classPrefix}__table__cell`}>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--desktop`}>Adult<br/> One Hotspur+<span className={`${classPrefix}__table__cell__content__price`}>From &pound;55</span></span>
											<span className={`${classPrefix}__table__cell__content ${classPrefix}__table__cell__content--mobile`}>Adult OH+</span>
										</div>
									</div>

									{memberBenefitsTableRows.map((row) => {
										return (
											<div className={`${classPrefix}__table__row`}>
												<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--title`}>{row.title}</p>
												{row.juniorOneHotspur.price !== '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--price`}>&pound;{row.juniorOneHotspur.price}</p>
												}
												{row.juniorOneHotspur.price === '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--${row.juniorOneHotspur.included ? `tick` : `minus`}`}>
														<span className={`${classPrefix}__icon ${classPrefix}__icon--${row.juniorOneHotspur.included ? `tick` : `minus`}`}>
															<span className={`${classPrefix}__icon__inner`}></span>
														</span>
														<span className="u-visually-hidden">{row.title} {row.juniorOneHotspur.included ? `included` : `excluded`} in Junior OneHotspur</span>
													</p>
												}
												{row.juniorOneHotspurPlus.price !== '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--price`}>&pound;{row.juniorOneHotspurPlus.price}</p>
												}
												{row.juniorOneHotspurPlus.price === '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--${row.juniorOneHotspurPlus.included ? `tick` : `minus`}`}>
														<span className={`${classPrefix}__icon ${classPrefix}__icon--${row.juniorOneHotspurPlus.included ? `tick` : `minus`}`}>
															<span className={`${classPrefix}__icon__inner`}></span>
														</span>
														<span className="u-visually-hidden">{row.title} {row.juniorOneHotspurPlus.included ? `included` : `excluded`} in Junior OneHotspur+</span>
													</p>
												}
												{row.adultOneHotspur.price !== '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--price`}>&pound;{row.adultOneHotspur.price}</p>
												}
												{row.adultOneHotspur.price === '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--${row.adultOneHotspur.included ? `tick` : `minus`}`}>
														<span className={`${classPrefix}__icon ${classPrefix}__icon--${row.adultOneHotspur.included ? `tick` : `minus`}`}>
															<span className={`${classPrefix}__icon__inner`}></span>
														</span>
														<span className="u-visually-hidden">{row.title} {row.adultOneHotspur.included ? `included` : `excluded`} in Adult OneHotspur</span>
													</p>
												}
												{row.adultOneHotspurPlus.price !== '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--price`}>&pound;{row.adultOneHotspurPlus.price}</p>
												}
												{row.adultOneHotspurPlus.price === '' &&
													<p className={`${classPrefix}__table__cell ${classPrefix}__table__cell--${row.adultOneHotspurPlus.included ? `tick` : `minus`}`}>
														<span className={`${classPrefix}__icon ${classPrefix}__icon--${row.adultOneHotspurPlus.included ? `tick` : `minus`}`}>
															<span className={`${classPrefix}__icon__inner`}></span>
														</span>
														<span className="u-visually-hidden">{row.title} {row.adultOneHotspurPlus.included ? `included` : `excluded`} in Adult OneHotspur+</span>
													</p>
												}
											</div>
										);
									})}

								</div>
							</div>
							<div className={`${classPrefix}__footer`}>
								<p className={`${classPrefix}__footer__prompt`}>Become a One Hotspur Member and start enjoying your benefits today!</p>
								<p className={`${classPrefix}__footer__button`}> 
									<a href="https://www.eticketing.co.uk/tottenhamhotspur/Memberships/List?utm_source=thfc&utm_medium=oh_page&utm_campaign=membership_acquistion2526_1_2025_6&utm_content=comparisontablecta" className="c-button c-button--right-arrow" rel="noopener external" target="_blank">Choose your membership</a>
								</p>
							</div>
						</div>

					</div>
				</div>
			</div>
		);
	}
};

module.exports = BenefitsTableModule;



// WEBPACK FOOTER //
// ./src/components/MemberBenefitsTable/MemberBenefitsTableModule.js